import { render, staticRenderFns } from "./recordList.vue?vue&type=template&id=07543f44&scoped=true&"
import script from "./recordList.vue?vue&type=script&lang=js&"
export * from "./recordList.vue?vue&type=script&lang=js&"
import style0 from "./recordList.vue?vue&type=style&index=0&id=07543f44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07543f44",
  null
  
)

export default component.exports